import { OnInit, Component, Input } from '@angular/core';
import { EmailLogService } from '../services/email-log.service';
import { MemberEmailView } from '../interface/member-email-view.interface';
import { MemberEmailInfo } from '../interface/member-email-info.interface';
import * as moment from 'moment';
import { CommonService } from '../../shared/services/common.service';
import { ActivityLogKey } from '../interface/activityLogKey';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { MemberEmailTypes } from '../enums/member-email-type.enum';
import { ResendMail } from '../enums/resend-mail.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';



@Component({
    selector: 'app-member-email-view',
    templateUrl: '../templates/template1/views/member-email-view.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less'
    ]

})
export class MemberEmailViewComponent implements OnInit {
    @Input() memberEmailInfo: MemberEmailInfo;

    memberEmailView: MemberEmailView;
    disableResend = true;
    memberTypeEnum = MemberTypeEnum;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    constructor(
        private _emailService: EmailLogService,
        private _commonService: CommonService,
      
    ) {

    }
    ngOnInit(): void {
        this.getEmailInformation();
    }

    /**
    * @description
    * @date 2019-07-10
    * @memberof MemberEmailLogComponent
    */
    getEmailInformation() {
        if (this.memberEmailInfo && this.memberEmailInfo.memberEmailLog && this.memberEmailInfo.memberEmailLog.id
            && this.memberEmailInfo.memberEmailLog.mailStatusId) {
            const templateId = this.memberEmailInfo.memberEmailLog.templateId;
            
                this._emailService.getMemberEmailDetails(this.memberEmailInfo.memberEmailLog.id
                , this.memberEmailInfo.memberEmailLog.mailStatusId)
                .subscribe(response => {
                    if (response) {
                        this.memberEmailView = response;
                        this.disableResend = (templateId === MemberEmailTypes.Password_Reset
                            || templateId === MemberEmailTypes.Password_Reset_link  || templateId === MemberEmailTypes.PrimaryEmailChange
                            || templateId === MemberEmailTypes.PrimaryEmail_UpdateInformation);            
                        if (this.memberEmailView && this.memberEmailView.templateStatusId ) {
                            this.disableResend = this.memberEmailView.templateStatusId === ResendMail.INACTIVE;
                        }
                        if (this.memberEmailView.body) {
                            this.memberEmailView.body = JSON.parse(this.memberEmailView.body as any);
                            this.memberEmailView.contentHtmlPart =
                            this.memberEmailView.body.content ? this.memberEmailView.body.content.htmlPart : 
                            (this.memberEmailView.body.emailBody ? this.memberEmailView.body.emailBody : '');
                        }
                        this.memberEmailView.createdDate = moment.utc(response.createdDate)
                            .utcOffset(this.memberEmailInfo.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');
                        this.memberEmailView.sentDate = moment.utc(response.sentDate)
                            .utcOffset(this.memberEmailInfo.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');

                    }
                });
        }
    }

    /**
     * @description Member Resend Mail
     * @date 2019-07-16
     * @memberof MemberEmailViewComponent
     */
    memberResendMail(): void {
        if (this.memberEmailInfo && this.memberEmailInfo.memberEmailLog && this.memberEmailInfo.memberEmailLog.id) {
            this._emailService.reSendMemberMail(this.memberEmailInfo.memberEmailLog.id)
                .subscribe(response => {
                    if (response) {
                        this._commonService.createNotification('', 'Email Resend Successfully', NotificationType.SUCCESS);
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Member_Email_Resent,
                            value: this.memberEmailInfo.memberEmailLog.emailId
                        }];
                        this._commonService.saveMemberActivity(this.memberEmailInfo.distributorInfo.memberId, activityLogKeys)
                            .subscribe(res => { }, (error: any) => { });
                    }
                });
        }

    }

   
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-email-view.component.ts